import DeleteSpecContainer from "./DeleteSpecContainer";
export default DeleteSpecContainer;
